<mat-toolbar class="h-auto bg-white p-2">
  <div class="container-fluid">
    <div class="row" *ngIf="config?.inventory">
      <h2 class="col-sm-4">{{ config.title }}</h2>
      <div class="col-sm-5 d-flex justify-content-between" *ngIf="!config?.hideInventoryCounts">
        <span class="font-weight-bold">Totals:</span>
        <span>Cars: {{ config.car }}</span>
        <span>|</span>
        <span>Loads: {{ config.load }}</span>
        <span>|</span>
        <span>Empties: {{ config.empty }}</span>
        <span>|</span>
        <span>Tons: {{ config.ton }}</span>
        <span>|</span>
        <span>Feet: {{ config.feet }}</span>
      </div>
    </div>
    <div class="row d-flex align-items-center" *ngIf="config?.accessorial">
      <h2 class="col-lg-3 col-md-2">{{ config.title }}</h2>
      <div class="col-lg-6 col-sm-3 d-flex justify-content-center">
        <div class="row">
          <div class="col-auto font-weight-bold">Totals:</div>
          <div class="col-auto">Cars: {{ config.car }}</div>
          <div class="col-auto">|</div>
          <div class="col-auto">Charges: {{ config.charges | currency }}</div>
        </div>
      </div>
      <div class="col-lg-3 col-sm-3" *ngIf="config.accessorial?.history">
        <div class="d-flex justify-content-end align-items-center">
          <span class="font-weight-bold mr-2">Billing Month</span>
          <mat-form-field appearance="outline" color="accent">
            <mat-label>Billing Month</mat-label>
            <mat-select
              aria-label="Select billing month"
              disableOptionCentering
              [(ngModel)]="previousMonthStartDate"
              (selectionChange)="monitorDate.emit($event.value.id)"
            >
              <mat-option *ngFor="let month of pastTwelveMonths" [value]="month">
                {{ month.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center" *ngIf="config?.billing">
      <h2 class="col-lg-3">{{ config.title }}</h2>
      <div class="col-lg-6 d-flex justify-content-between" *ngIf="config.billing?.candidate">
        <span class="font-weight-bold">Totals:</span>
        <span>Credits: {{ config.credits }}</span>
        <span>|</span>
        <span>Service Credits: {{ config.serviceCredits }}</span>
        <span>|</span>
        <span>Adjusted Credits: {{ config.adjustedCredits }}</span>
        <span>|</span>
        <span>Car Days: {{ config.carDays }}</span>
        <span>|</span>
        <span>Total: <span [ngClass]="{ 'text-danger': config.total! < 0 }">{{ total(config.total!) }}</span></span>
        <span>|</span>
        <span>Est Charges: {{ config.estCharge | currency }}</span>
      </div>
      <div class="col-lg-6" *ngIf="config?.billing?.privateStorageCar">
        <div class="d-flex justify-content-between align-items-center pcs-height">
          <span class="font-weight-bold">Totals:</span>
          <span>Credits: {{ config.credits }}</span>
          <span>|</span>
          <span>Service Credits: {{ config.serviceCredits }}</span>
          <span>|</span>
          <span>Adjusted Credits: {{ config.adjustedCredits }}</span>
          <span>|</span>
          <span>Car Days: {{ config.carDays }}</span>
          <span>|</span>
          <span>Total: <span [ngClass]="{ 'text-danger': config.total! < 0 }">{{ total(config.total!) }}</span></span>
          <span>|</span>
          <span>Est Charges: {{ config.estCharge | currency }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center pcs-height">
          <span class="font-weight-bold">Totals:</span>
          <span>Credits: {{ config.creditsOne }}</span>
          <span>|</span>
          <span>Service Credits: {{ config.serviceCreditsOne }}</span>
          <span>|</span>
          <span>Adjusted Credits: {{ config.adjustedCreditsOne }}</span>
          <span>|</span>
          <span>Car Days: {{ config.carDaysOne }}</span>
          <span>|</span>
          <span>Total: <span [ngClass]="{ 'text-danger': config.totalOne! < 0 }">{{ total(config.totalOne!) }}</span></span>
          <span>|</span>
          <span>Est Charges: {{ config.estChargeOne | currency }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center pcs-height">
          <span class="font-weight-bold">Totals:</span>
          <span>Credits: {{ config.creditsTwo }}</span>
          <span>|</span>
          <span>Service Credits: {{ config.serviceCreditsTwo }}</span>
          <span>|</span>
          <span>Adjusted Credits: {{ config.adjustedCreditsTwo }}</span>
          <span>|</span>
          <span>Car Days: {{ config.carDaysTwo }}</span>
          <span>|</span>
          <span>Total: <span [ngClass]="{ 'text-danger': config.totalTwo! < 0 }">{{ total(config.totalTwo!) }}</span></span>
          <span>|</span>
          <span>Est Charges: {{ config.estChargeTwo | currency }}</span>
        </div>
      </div>
      <div class="col-lg-3 d-flex justify-content-end align-items-center">
        <ng-container *ngIf="config?.billing?.accrual">
          <span class="font-weight-bold mr-2">Accrual Status:</span>
          <mat-radio-group [(ngModel)]="accrualSelected" (change)="accrual.emit($event.value)">
            <mat-radio-button value="close">Closed</mat-radio-button>
            <mat-radio-button value="open" class="ml-3">Open</mat-radio-button>
          </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="config?.billing?.billingMonth">
          <span class="font-weight-bold mr-2">Billing Month</span>
          <mat-form-field appearance="outline" color="accent">
            <mat-label>Billing Month</mat-label>
            <mat-select
              aria-label="Select billing month"
              disableOptionCentering
              [(ngModel)]="previousMonthStartDate"
              (selectionChange)="billingDate.emit($event.value.id)"
            >
              <mat-option *ngFor="let month of pastTwelveMonths" [value]="month">
                {{ month.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </div>
    </div>
    <div class="row d-flex align-items-center" *ngIf="config?.dispute">
      <h2 class="col-sm-3">{{ config.title }}</h2>
      <div class="col-sm-9 d-flex justify-content-end align-items-center">
        <span class="font-weight-bold mr-2">Billing Month</span>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Billing Month</mat-label>
          <mat-select
            aria-label="Select billing month"
            disableOptionCentering
            [(ngModel)]="currentMonthStartDate"
            (selectionChange)="disputeDate.emit($event.value.id)"
          >
            <mat-option *ngFor="let month of pastThirteenMonths" [value]="month">
              {{ month.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="config?.serviceRequest">
      <form [formGroup]="serviceForm" class="w-100 d-flex">
        <h2 class="col-sm-3 d-flex align-self-center">{{ config.title }}</h2>
        <div class="col-sm-6 d-flex justify-content-center align-self-center">
          <span class="font-weight-bold mr-2">Report Type:</span>
          <mat-radio-group formControlName="reportType" (change)="emit($event.value)">
            <mat-radio-button value="O">Open Service Requests</mat-radio-button>
            <mat-radio-button value="H" class="ml-3">Service Request History</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="col-sm-3 d-flex">
          <ng-container *ngIf="serviceForm.controls.reportType.value === 'H'">
            <mat-form-field class="w-75" appearance="outline" color="accent">
              <mat-label>Select a Date</mat-label>
              <mat-date-range-input [rangePicker]="picker" [min]="minDate">
                <input matStartDate aria-label="Start date" formControlName="startDate" placeholder="Start Date">
                <input matEndDate aria-label="End date" formControlName="endDate" placeholder="End Date">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <button mat-flat-button aria-label="Search" class="w-25 ml-1" color="accent" (click)="emit(serviceForm.controls.reportType.value)">
              Search
            </button>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
</mat-toolbar>
